/**
 * Where a floating panel of `element` goes: the nearest open <dialog> (top layer), else the nearest `[data-jui-portal]`
 * (an embedded widget keeps its panels inside its own root, so the host's styles and handlers see them as the widget's),
 * else <body>.
 */
export function portalContainer(element) {
    return element?.closest("dialog, [data-jui-portal]") ?? document.body;
}
